<template>
  <v-container>
    <v-tabs v-model="activeTab" background-color="primary" dark>
      <v-tab @click="navigateToTab('templates')">Templates</v-tab>
      <v-tab @click="navigateToTab('communication')">Communications</v-tab>
    </v-tabs>

    <v-tabs-items v-model="activeTab">
      <!-- TAB 1: Templates -->
      <v-tab-item>
    <v-card>
      <v-card-title class="d-flex align-center">
        <v-icon
          color="primary"
          @click="openEditDialog(null)"
          style="cursor: pointer"
          >add</v-icon
        >
        <v-divider vertical class="mx-2" />
        <!-- ✅ ADD: Free text search field -->
        <v-text-field
          v-model="searchText"
          label="Search templates..."
          prepend-inner-icon="search"
          clearable
          dense
          hide-details
          style="max-width: 250px"
          class="mr-2"
        />
        <v-divider vertical class="mx-2" />
        <v-select
          v-model="selectedType"
          :items="uniqueTypes"
          label="Filter by Type"
          clearable
          dense 
          style="max-width: 200px"
        />
        <v-divider vertical class="mx-2" />
        <v-select
          v-model="selectedIndustry"
          :items="uniqueIndustry"
          label="Filter by Industry"
          clearable
          dense
          style="max-width: 200px"
        />
        <v-divider vertical class="mx-2" />
        <v-select
          v-model="selectedState"
          :items="uniqueState"
          label="Filter by State"
          clearable
          dense
          style="max-width: 200px"
        />
        <v-divider vertical class="mx-2" />
        <v-checkbox
          v-model="myClubOnly"
          label="My Club Only"
          class="mt-2"
        />

      </v-card-title>

      <v-data-table
        :headers="headers"
        :items="filteredTemplates"
        :loading="loading"
        item-value="seqNo"
        class="elevation-1"
        :items-per-page="50"
        sort-by="updateDate"
        sort-desc         
      >
        <template #item.body="{ item }">
          <v-tooltip bottom>
            <template #activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on" class="text-truncate">
                {{ truncateText(stripHtml(item.body), 30) }}
              </div>
            </template>
            <span>{{ stripHtml(item.body) }}</span>
          </v-tooltip>
        </template>

        <template #item.actions="{ item }">
                    <!-- v-menu that is triggered by the three dots button -->
                    <v-menu offset-y open-on-hover>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn x-small color="primary" dark v-bind="attrs" v-on="on">
                          <v-icon small>more_vert</v-icon>
                        </v-btn>
                      </template>
                      <!-- Menu content (will only be visible when the menu is active) -->
                      <v-list>
                        <!-- Edit Action -->
                        <v-list-item @click="openSendDialog(item)"">
                          <v-list-item-icon>
                            <v-icon>send</v-icon>
                            <!-- Edit icon -->
                          </v-list-item-icon>
                          <v-list-item-title>Run Template </v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="openEditDialog(item)">
                          <v-list-item-icon>
                            <v-icon>edit</v-icon>
                            <!-- Edit icon -->
                          </v-list-item-icon>
                          <v-list-item-title>Edit</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="duplicateTemplate(item)">
                          <v-list-item-icon>
                            <v-icon>control_point_duplicate</v-icon>
                            <!-- Edit icon -->
                          </v-list-item-icon>
                          <v-list-item-title>Duplicate</v-list-item-title>
                        </v-list-item>

                        <!-- <v-btn x-small @click="sendEmail(item.node)">
                    {{ item.node.email }}
                  </v-btn> -->

                        <!-- Delete Action -->
                        <v-list-item @click="deleteItem(item)">
                          <v-list-item-icon>
                            <v-icon>delete</v-icon>
                            <!-- Delete icon -->
                          </v-list-item-icon>
                          <v-list-item-title>Delete</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="editDialog" max-width="1200px">
      <v-card>
        <v-card-title>{{ formTitle }}</v-card-title>

        <v-card-text>
          <v-container fluid>
            <v-row dense>
              <v-col cols="4" sm="4">
                <v-text-field
                  v-model="editedItem.name"
                  label="Name"
                  :rules="[requiredRule, noSpacesRule]"
                  @input="sanitizeName"
                  dense
                />
              </v-col>
              <v-col cols="4" sm="4">
                <catValueDropDown
                  :outlined="true"
                  :catName="'COMMUNICAT_TYPE'"
                  v-model.trim="editedItem.type"
                  label="Communication type"
                  :rules="[requiredRule]"
                />
              </v-col>
              <v-col cols="4" sm="4">
                <catValueDropDown
                  :outlined="true"
                  :catName="'INDUSTRY'"
                  v-model.trim="editedItem.industry"
                  label="Industry"
                  :rules="[requiredRule]"
                />
              </v-col>
              <v-col cols="4" sm="4">
                <catValueDropDown
                  :outlined="true"
                  :catName="'MESSAGE_TEMPLATE_STATE'"
                  v-model.trim="editedItem.state"
                  label="State"
                  :rules="[requiredRule]"
                />
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="editedItem.description"
                  label="Description"
                  auto-grow
                  rows="1"
                  no-resize
                  dense
                  :rules="[requiredRule]"
                />
              </v-col>

              <v-col>
                <v-text-field v-model="editedItem.subject" label="Subject" />
              </v-col>
            </v-row>

            <v-row dense>
              <v-col>
                <quillEditor
                  ref="quillEditor"
                  v-model="editedItem.body"
                  :options="{ theme: 'snow' }"
                  label="Body"
                  style="min-height: 400px"
                  :rules="[requiredRule]"
                />
                <div v-if="invalidVariables.length" class="mt-2">
                  <span class="red--text font-weight-bold">Unknown variables:</span>
                  <v-chip
                    v-for="v in invalidVariables"
                    :key="v"
                    color="red lighten-2"
                    small
                    class="ml-1"
                  >
                    {{ v }}
                  </v-chip>
                </div>
              </v-col>

              <!-- Available Variables (side bar) -->
              <v-col cols="2">
    <div>Available Variables</div>
    <v-text-field
      v-model="variableFilter"
      dense
      hide-details
      placeholder="Filter variables..."
      class="mb-2"
      clearable
      prepend-inner-icon="search"
    />
    <div class="cat-val-list-scroll">
      <v-chip
        v-for="(variable, idx) in filteredAvailableVariables"
        :key="idx"
        small
        class="mb-1 mr-1"
        @click="insertVariable(variable)"
        style="cursor:pointer"
        color="primary"
        outlined
      >
        {{ variable }}
      </v-chip>
    </div>
  </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn text @click="editDialog = false">Close</v-btn>
          <v-btn color="primary" @click="save">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="sendDialog" max-width="1200px">
  <v-card>
    <v-card-title>{{ formTitle }}</v-card-title>

    <v-card-text>
<v-container fluid>
  <!-- Section Title -->
  <v-row class="mb-2">
    <v-col cols="12">
      <h3 class="text-subtitle-1 font-weight-medium mb-1">Filter Athletes</h3>
      <v-divider />
    </v-col>
  </v-row>

  <!-- Filter Card -->
  <v-card outlined class="pa-3 mb-4">
    <v-row dense class="align-center">
      <!-- Competitive Toggle -->
      <v-col cols="12" sm="6" md="3" class="d-flex align-center">
        <div class="d-flex align-center flex-grow-1">
          <span class="mr-2 text-caption font-weight-medium" style="min-width: 40px;">Group Type:</span>
          <v-btn-toggle
            v-model="competitiveFlag"
            dense
            mandatory
            style="height: 36px;"
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn :value="null" small v-bind="attrs" v-on="on" min-width="0">
                  <v-icon small>group</v-icon>
                </v-btn>
              </template>
              <span>All</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn :value="1" small v-bind="attrs" v-on="on" min-width="0">
                  <v-icon small>emoji_events</v-icon>
                </v-btn>
              </template>
              <span>Competitive</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn :value="0" small v-bind="attrs" v-on="on" min-width="0">
                  <v-icon small>pool</v-icon>
                </v-btn>
              </template>
              <span>Non-Competitive</span>
            </v-tooltip>
          </v-btn-toggle>
        </div>
      </v-col>

      <!-- Teams -->
      <v-col cols="12" sm="6" md="3">
                <div class="d-flex align-center">
          <span>Include</span>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="ml-1" color="grey" v-bind="attrs" v-on="on">help_outline</v-icon>
            </template>
            <span>Include selected groups in the email list</span>
          </v-tooltip>
        </div>
        <GroupSelect
          v-model="selectedTeams"
          :rules="[requiredRule]"
          :competitive-flag="competitiveFlag"
          outlined
          dense
          clearable
          label="Teams"
          chips
          small-chips
        />
      </v-col>

      <!-- Exclude -->
      <v-col cols="12" sm="6" md="3">
        <div class="d-flex align-center">
          <span>Exclude</span>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="ml-1" color="grey" v-bind="attrs" v-on="on">help_outline</v-icon>
            </template>
            <span>Exclude selected groups from the email list</span>
          </v-tooltip>
        </div>
        <GroupSelect
          v-model="excludeGroups"
          :multiple="true"
          :competitive-flag="competitiveFlag"
          outlined
          dense
          clearable
          label="Exclude"
          chips
          small-chips
        />
      </v-col>

      <!-- Status -->
      <v-col cols="12" sm="6" md="3">
        <StatusMultiSelect
          v-model="selectedStatus"
          :update-router="null"
          cat-name="athlete_status"
          outlined
          dense
          clearable
          label="Status"
        />
      </v-col>
    </v-row>

    <!-- Second Row -->
    <v-row dense class="align-center mt-2">
      <!-- Athlete Emails -->
      <!-- In Event(s) -->
      <v-col cols="12" sm="6" md="4">
                        <div class="d-flex align-center">
          <span>Include Events</span>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="ml-1" color="grey" v-bind="attrs" v-on="on">help_outline</v-icon>
            </template>
            <span>Include selected events</span>
          </v-tooltip>
        </div>
        <EventCatalogSelect
          v-model="selectedEvent"
          :multiple="true"
          outlined
          dense
          clearable
          label="In Event(s)"
          chips
          small-chips
        />
      </v-col>

      <!-- Not In Event(s) -->
      <v-col cols="12" sm="6" md="4">
                        <div class="d-flex align-center">
          <span>Not In Event(s)</span>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="ml-1" color="grey" v-bind="attrs" v-on="on">help_outline</v-icon>
            </template>
            <span>Not In Event(s) filter</span>
          </v-tooltip>
        </div>
        <EventCatalogSelect
          v-model="selectedNotInEvent"
          :multiple="true"
          outlined
          dense
          clearable
          label="Not In Event(s)"
          chips
          small-chips
        />
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <div class="mb-1 text-caption grey--text">
          {{ groupEmails.length }} athlete{{ groupEmails.length === 1 ? '' : 's' }} found
        </div>
        <v-autocomplete
          v-model="selectedGroupEmails"
          :items="groupEmails"
          item-value="node.email"
          :item-text="formatAthleteOption"
          label="Athlete Emails"
          multiple
          chips
          small-chips
          outlined
          dense
          clearable
          :rules="[requiredRule]"
        />
      </v-col>
      
        <v-btn small text color="secondary" @click="clearAllFilters" class="ml-2">
          <v-icon small>person</v-icon>Clear All
        </v-btn>
    </v-row>
  </v-card>
</v-container>



    </v-card-text>

    <v-card-actions>
      <v-spacer />
      <v-btn text @click="sendDialog = false">Close</v-btn>
      <v-btn color="primary" @click="sendTemplate">Send</v-btn>
    </v-card-actions>

    <v-divider class="my-2" />

    <v-card-text>
      <h3 class="text-h6 mb-2">Message Preview</h3>
      <v-row dense>
        <v-col cols="12">
          <div
            class="preview-pane"
            v-html="highlightedBody"
            style="border: 1px solid #ccc; padding: 16px; min-height: 300px; border-radius: 8px; background: #fafafa; overflow-y: auto;"
          />
        </v-col>
      </v-row>
    </v-card-text>

  </v-card>
</v-dialog>
</v-tab-item>

<!-- TAB 2: Communication -->
<v-tab-item>
  <v-card class="mt-4 pa-4">
    <Communications />
  </v-card>
</v-tab-item>
</v-tabs-items>
  </v-container>
</template>

<script>
import { mapGetters,mapActions } from "vuex";
import DOMPurify from "dompurify";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import catValueDropDown from "../../shared/cat_val_dropdown.vue";
//import SendTemplateDialog from "./send-template-dialog.vue";
import Communications from "./PersonCommunications.vue";
import EventCatalogSelect from "../../shared/selectEventCatalog.vue";
import GroupSelect from "../../shared/selectGroup.vue";
import StatusMultiSelect from "@/components/shared/StatusMultiSelect.vue";
import { getCatValues } from "@/mixins/getCatValues.js"; // adjust path as needed

export default {
  mixins: [getCatValues],
  components: {
    quillEditor,
    catValueDropDown,
    Communications,
    EventCatalogSelect,
    GroupSelect,
    StatusMultiSelect,
    //SendTemplateDialog,
  },
  data() {
    return {
      activeTab: 0, // 0 = Templates, 1 = Communication
      tabMap: {
        templates: 0,
        communication: 1,
      },
      loading: true,
      loadingClubPersonRel: false, // ✅ ADD: Separate loading state for clubPersonRel
      sendDialog: false,
      selectedStatus: ["test"],
      editDialog: false,
      editedIndex: -1,
      editedItem: {},
      selectedTeams: [],
      selectedGroupEmails: [],
      // selectedType: null,
      // selectedIndustry: null,
      competitiveFlag: null,
      teams: [],
      groupEmails: [],
      myClubOnly: false, // checkbox state
      currentClubId: this.$store.state.Clubs.club,
      createDuplicate: false,
      selectedEvent: [],
      selectedNotInEvent: [],
      excludeGroups: [],
      headers: [
        { text: "Actions", value: "actions", sortable: false },
        { text: "Name", value: "name" },
        { text: "Subject", value: "subject" },
        { text: "Description", value: "description" },
        { text: "Type", value: "type" },
        { text: "Body", value: "body", sortable: false },
        { text: "Industry", value: "industry" },
        { text: "Club Id", value: "clubId" },
        // { text: "League Id", value: "leagueId" },
        { text: "State", value: "state" },
        { text: "Created", value: "createDate" },
        { text: "Updated", value: "updateDate" },
      ],
      templates: [],
      variableFilter: "",
      searchText: '',
    };
  },
  computed: {
    ...mapGetters(["user", "allMessageTemplates", "clubInfo", "clubPersonRel"]),
    invalidVariables() {
      if (!this.editedItem.body) return [];
      const matches = [...this.editedItem.body.matchAll(/\{([^}]+)\}/g)];
      return matches
        .map((m) => m[1].trim())
        .filter((v) => !this.availableVariables.includes(v))
        .filter((v, i, arr) => arr.indexOf(v) === i); // unique
    },
    selectedType: {
      get() {
        return this.$route.query.type || null;
      },
      set(value) {
        const query = { ...this.$route.query, type: value || undefined };
        this.$router.replace({ query });
      },
    },
    selectedIndustry: {
      get() {
        return this.$route.query.industry || null;
      },
      set(value) {
        const query = { ...this.$route.query, industry: value || undefined };
        this.$router.replace({ query });
      },
    },
    selectedState: {
      get() {
        return this.$route.query.state || null;
      },
      set(value) {
        const query = { ...this.$route.query, state: value || undefined };
        this.$router.replace({ query });
      },
    },
    clubId() {
      const id = this.$store.state.Clubs.club;
      return id !== "undefined" && id !== undefined ? id : null;
    },
    filteredTemplates() {
      return this.templates.filter((t) => {
        const typeMatches = this.selectedType
          ? t.type === this.selectedType
          : true;
        const industryMatches = this.selectedIndustry
          ? t.industry === this.selectedIndustry
          : true;
        const stateMatches = this.selectedState
          ? t.state === this.selectedState
          : true;
        const clubMatches =
          this.myClubOnly && this.clubId ? t.clubId == this.clubId : true;
        //: t.clubId == this.clubId || t.clubId === null; // timely clubId population must be fixed
        const searchMatches = this.searchText
        ? this.matchesSearch(t, this.searchText.toLowerCase())
        : true;
        return typeMatches && industryMatches && stateMatches && clubMatches && searchMatches;
      });
    },
    
    uniqueTypes() {
      return [...new Set(this.templates.map((t) => t.type))];
    },
    uniqueIndustry() {
      return [...new Set(this.templates.map((t) => t.industry))];
    },
    uniqueState() {
      return [...new Set(this.templates.map((t) => t.state))];
    },
    formTitle() {
      return this.editedIndex === -1
        ? "New Message Template"
        : "Run Message Template " + this.editedItem.name;
    },
    sanitizedBody() {
      return DOMPurify.sanitize(this.editedItem.body || "");
    },
    availableVariables() {
      // Make sure this returns an array of strings
      return this.catValueListArray
        ? this.catValueListArray("MESSAGE_VARIABLES").map((v) =>
            typeof v === "string" ? v : v.value || v.text || v.label || ""
          )
        : [];
    },
    highlightedBody() {
      if (!this.editedItem.body) return "";

      // Debug: See what availableVariables contains
      console.log("Available Variables:", this.availableVariables);

      // Find all {variable} in the body
      return this.editedItem.body.replace(/\{([^}]+)\}/g, (match, varName) => {
        const cleanVar = varName.trim();
        if (this.availableVariables.includes(cleanVar)) {
          return match;
        } else {
          return `<span style="color:red;font-weight:bold">${match}</span>`;
        }
      });
    },
    filteredAvailableVariables() {
      if (!this.variableFilter) return this.availableVariables;
      const filter = this.variableFilter.toLowerCase();
      return this.availableVariables.filter(v =>
        v && v.toLowerCase().includes(filter)
      );
    },
  },
  watch: {
    selectedTeams() {
      this.groupEmails = this.getSelectedGroupEmails();
    },
    selectedStatus() {
      this.groupEmails = this.getSelectedGroupEmails();
    },
    excludeGroups() {
      this.groupEmails = this.getSelectedGroupEmails();
    },
    // ✅ ADD: Watch for event filter changes
    selectedEvent() {
      this.groupEmails = this.getSelectedGroupEmails();
    },
    selectedNotInEvent() {
      this.groupEmails = this.getSelectedGroupEmails();
    },
    allMessageTemplates: {
      handler(val) {
        this.templates = val.edges.map((e) => e.node);
      },
      immediate: true,
      deep: true,
    },
  },
  async created() {
    try {
      // ✅ PARALLEL: Load both at the same time
      await Promise.all([
        this.$store.dispatch("allClubPersonRel"),
        this.$store.dispatch("allMessageTemplates")
      ]);
      
      console.log('✅ Data loaded successfully');
      console.log('📊 ClubPersonRel count:', this.$store.getters.clubPersonRel.length || 0);
    } catch (error) {
      console.error('❌ Error loading data:', error);
      this.$toast.error('Error loading data');
    } finally {
      this.loading = false;
    }
  },
  methods: {
    ...mapActions([
      "allClubPersonRel",
    ]),
    matchesSearch(template, searchTerm) {
        if (!searchTerm) return true;
        
        // Split search term into words for AND search
        const searchWords = searchTerm.split(' ').filter(word => word.length > 0);
        
        // Create searchable text from all fields
        const searchableText = [
          template.name,
          template.subject, 
          template.description,
          this.stripHtml(template.body || ''), // Remove HTML tags
          template.type,
          template.industry,
          template.state
        ].join(' ').toLowerCase();
        
        // All search words must be found (AND logic)
        return searchWords.every(word => 
          searchableText.includes(word)
        );
      },
    formatAthleteOption(item) {
      return `${item.firstName} ${item.lastName} (${item.email})`;
    },
    navigateToTab(tabName) {
      const index = this.tabMap[tabName];
      if (index !== undefined) {
        this.activeTab = index;
        this.$router.replace({ query: { ...this.$route.query, tab: tabName } });
      }
    },
    // ✅ DEBUG: Add this method to see clubPersonRel structure
    debugClubPersonRel() {
      const clubPersonRel = this.$store.getters.clubPersonRel || [];
      if (clubPersonRel.length > 0) {
        console.log('🔍 Sample clubPersonRel structure:', JSON.stringify(clubPersonRel[0], null, 2));
        console.log('🔍 Total clubPersonRel records:', clubPersonRel.length);
      } else {
        console.log('🔍 No clubPersonRel data available');
      }
    },
    openEditDialog(item) {
      console.log(item);
      this.editedIndex = item
        ? this.templates.findIndex((t) => t.seqNo === item.seqNo)
        : -1;
      this.editedItem = item
        ? { ...item }
        : {
            seqNo: 0,
            name: "",
            subject: "",
            body: "",
            description: "",
            type: "Email",
            state: "draft",
            industry: "SPORT",
            createDate: new Date().toISOString().split("T")[0],
            updateSource: this.user.userName,
          };
      this.editDialog = true;
    },
    duplicateTemplate(item) {
      this.createDuplicate = true;
      item.name = item.name + "_copy1";
      item.seqNo = 0;
      this.openEditDialog(item);
    },

    openSendDialog(item) {
      console.log;
      this.teams = this.clubInfo.edges
        .filter((item) => item.node.clubId == this.$route.params.club)[0]
        .node.team.edges.sort((a, b) => a.node.orderOnUi - b.node.orderOnUi);
      console.log(this.teams);
      this.editedIndex = item
        ? this.templates.findIndex((t) => t.seqNo === item.seqNo)
        : -1;
      this.editedItem = item
        ? { ...item }
        : {
            seqNo: 0,
            name: "",
            subject: "",
            body: "",
            description: "",
            type: "Email",
            state: "draft",
            industry: "SPORT",
            createDate: new Date().toISOString().split("T")[0],
            updateSource: this.user.userName,
          };
      this.sendDialog = true;
      
      // ✅ ADD: Debug athlete structure
      this.$nextTick(() => {
        this.debugAthleteStructure();
      });
    },
getSelectedGroupEmails() {
  const selectedGroupEmails = [];
  const emailSet = new Set();

  // ✅ USE: clubPersonRel from store instead of teams
  const clubPersonRel = this.$store.getters.clubPersonRel || [];
  
  if (!clubPersonRel || !Array.isArray(clubPersonRel) || clubPersonRel.length === 0) {
    console.log('No clubPersonRel data available');
    return selectedGroupEmails;
  }

  if (!this.selectedStatus || this.selectedStatus.length === 0) {
    console.log('No status selected');
    return selectedGroupEmails;
  }

  // Get array of group names to exclude
  const excludeGroupNames = this.excludeGroups.map((g) => g.teamName || g);
  console.log('Exclude groups:', excludeGroupNames);
  console.log('Selected Events (Include):', this.selectedEvent);
  console.log('Selected Events (Exclude):', this.selectedNotInEvent);

  clubPersonRel.forEach((relation) => {
    const person = relation.person;
    const team = relation.group;
    
    // ✅ FIX: Skip if no person or team data
    if (!person || !team) {
      console.log('Skipping relation with missing person or team data');
      return;
    }

    // ✅ FIX: Skip if team is in excludeGroups
    if (excludeGroupNames.includes(team.teamName)) {
      console.log(`Skipping excluded team: ${team.teamName}`);
      return;
    }

    // ✅ FIX: Team selection filter
    const teamSelected = this.selectedTeams && this.selectedTeams.length > 0
      ? this.selectedTeams.includes(team.teamName)
      : true; // If no teams selected, include all non-excluded teams

    if (!teamSelected) {
      console.log(`Team not selected: ${team.teamName}`);
      return;
    }

    // ✅ FIX: Validate person data
    if (!person.email || !relation.status) {
      console.log(`Skipping person with missing data:`, person);
      return;
    }

    // ✅ FIX: Check status filter
    if (!this.selectedStatus.includes(relation.status)) {
      console.log(`Person ${person.firstName} ${person.lastName} status ${relation.status} not in selected statuses`);
      return;
    }

    // ✅ FIX: Event filtering logic - each relation has ONE event
    let personEventId = null;
    
    // Get the event ID from the relation's event object
    if (relation.event && relation.event.eventId) {
      personEventId = relation.event.eventId;
    }
    
    console.log(`Person ${person.firstName} ${person.lastName} event: ${personEventId} (${relation.event.name || 'No event name'})`);

    // ✅ INCLUDE EVENT FILTER: If events are selected, person must be in at least one
    if (this.selectedEvent && this.selectedEvent.length > 0) {
      if (!personEventId || !this.selectedEvent.includes(personEventId)) {
        console.log(`Person ${person.firstName} ${person.lastName} not in selected events. Person event: ${personEventId}, Selected: [${this.selectedEvent.join(', ')}]`);
        return;
      }
    }

    // ✅ EXCLUDE EVENT FILTER: If exclude events are selected, person must NOT be in any
    if (this.selectedNotInEvent && this.selectedNotInEvent.length > 0) {
      if (personEventId && this.selectedNotInEvent.includes(personEventId)) {
        console.log(`Person ${person.firstName} ${person.lastName} in excluded events. Person event: ${personEventId}, Excluded: [${this.selectedNotInEvent.join(', ')}]`);
        return;
      }
    }

    // ✅ FIX: Check for duplicate emails
    if (emailSet.has(person.email)) {
      console.log(`Duplicate email skipped: ${person.email}`);
      return;
    }

    // ✅ FIX: Add to results
    emailSet.add(person.email);
    selectedGroupEmails.push({
      email: person.email,
      firstName: person.firstName,
      lastName: person.lastName,
      status: relation.status,
      teamName: team.teamName,
      personId: person.id,
      relationId: relation.seqNo,
      eventId: personEventId, // ✅ CHANGE: Single event ID
      eventName: relation.event.name || 'No event', // ✅ ADD: Event name for display
      // ✅ ADD: Additional useful data from clubPersonRel
      teamId: team.id,
      startMembership: relation.startMembership,
      endMembership: relation.endMembership,
      competitive: team.competitive
    });

    console.log(`Added person: ${person.firstName} ${person.lastName} (${person.email}) from ${team.teamName} - Event: ${relation.event.name || 'No event'}`);
  });

  console.log(`Final result: ${selectedGroupEmails.length} unique people selected`);
  return selectedGroupEmails;
},

    async save() {
      const payload = { ...this.editedItem };
      if (!payload.seqNo) delete payload.seqNo;

      payload.updateSource = this.user.userName;
      if (this.createDuplicate) {
        payload.seqNo = 0;
        payload.clubId = this.clubId;
        this.createDuplicate = false;
        //payload.name = payload.name + "_copy1"
      }
      console.log(payload);
      await this.$store.dispatch("messageTemplatesMerge", payload);
      this.editDialog = false;
      await this.$store.dispatch("allMessageTemplates");
    },

    async sendTemplate() {
      if (!this.selectedTeams.length && !this.selectedStatus.length) {
        this.$toast.error("Please select at least one team or one status.");
        return;
      }

      this.loading = true;

      const payload = {
        jobName: "email_job",
        jobParams: {
          clubName: "Rocket Swim Club",
          competitiveFlag: this.competitiveFlag,
          groups: this.selectedTeams,
          status: this.selectedStatus,
          emailTemplate: this.editedItem.name || "welcome",
          emailList: this.selectedGroupEmails || "support@sportecos.com",
          eventId: this.selectedEvent, // now an array
          notInEventId: this.selectedNotInEvent, // now an array
          excludeGroups: this.excludeGroups.map((g) => g.teamName || g), // array of group names
        },
      };

      try {
        const response = await this.$store.dispatch("triggerJob", payload);

        let jobResult = null;
        if (response && response.result) {
          jobResult = response.result;
        } else if (
          response &&
          response.data &&
          response.data.triggerJob &&
          response.data.triggerJob.result
        ) {
          jobResult = response.data.triggerJob.result;
        }

        let sent = 0;
        let failed = 0;

        if (response && response.success && jobResult) {
          try {
            const parsed = JSON.parse(jobResult);
            sent = parsed.sent || 0;
            failed = parsed.failed || 0;
          } catch (e) {
            console.warn("Could not parse result:", jobResult);
          }

          // ✅ Show plain toast message
          this.$toast.success(`✅ ${sent} sent, ❌ ${failed} failed.`);

          // ✅ Ask user if they want to continue
          // if (
          //   window.confirm("Do you want to continue to the Communication tab?")
          // ) {
          //   this.navigateToTab("communication");
          // }
        } else {
          const message =
            response && response.message
              ? response.message
              : response &&
                response.data &&
                response.data.triggerJob &&
                response.data.triggerJob.message
              ? response.data.triggerJob.message
              : "Job failed.";

          this.$toast.error("Failed: " + message);
        }
      } catch (error) {
        console.error(error);
        this.$toast.error("Error sending template.");
      } finally {
        this.loading = false;
      }
    },
    truncateText(text, length) {
      return text && text.length > length
        ? text.substring(0, length) + "..."
        : text;
    },
    stripHtml(html) {
      return DOMPurify.sanitize(html, { ALLOWED_TAGS: [] });
    },
    requiredRule(v) {
      return !!v || "Name is required";
    },
    noSpacesRule(v) {
      return /^\S*$/.test(v) || "No spaces allowed";
    },
    sanitizeName() {
      // This will immediately remove any spaces while typing
      this.editedItem.name = this.editedItem.name.replace(/\s/g, "");
    },
    deleteItem(item) {
      if (confirm("Are you sure you want to delete this item?")) {
        this.$store.dispatch("messageTemplatesDelete", {
          seqNo: item.seqNo,
        });
      }
    },
    clearAllFilters() {
      this.competitiveFlag = null;
      this.selectedTeams = [];
      this.excludeGroups = [];
      this.selectedStatus = [];
      this.selectedEvent = [];
      this.selectedNotInEvent = [];
      this.selectedGroupEmails = [];
    },
    insertVariable(variable) {
      // Insert at cursor position in Quill (Vue 2 compatible)
      const quillEditor = this.$refs.quillEditor;
      const quill = quillEditor && quillEditor.quill;
      if (quill) {
        var selection = quill.getSelection(true);
        var cursorPosition =
          selection && typeof selection.index === "number"
            ? selection.index
            : quill.getLength();
        quill.insertText(cursorPosition, "{" + variable + "}");
        quill.setSelection(cursorPosition + ("{" + variable + "}").length);
        quill.focus();
      }
    },
    // ✅ TEMPORARY: Add this method to debug athlete data structure
    debugAthleteStructure() {
      if (this.teams && this.teams.length > 0) {
        const firstTeam = this.teams[0].node;
        if (firstTeam.athlete && firstTeam.athlete.edges.length > 0) {
          const firstAthlete = firstTeam.athlete.edges[0].node;
          console.log('🔍 Sample athlete structure:', JSON.stringify(firstAthlete, null, 2));
        }
  }
},
  },
  mounted() {
    const tabName = this.$route.query.tab;
    document.addEventListener("goto-comm-tab", () => {
      this.navigateToTab("communication");
    });
    this.activeTab =
      this.tabMap[tabName] !== undefined ? this.tabMap[tabName] : 0;
  },
};
</script>

<style scoped>
.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.preview-pane {
  background: #fafafa;
  border-radius: 8px;
}

.compact-toggle {
  /* Custom styles for the compact toggle */
  min-width: 0;
  padding: 0;
}

.compact-toggle .v-btn {
  min-width: 32px !important;
  padding: 0 2px !important;
  font-size: 12px !important;
}

.cat-val-list-scroll {
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #eee;
  border-radius: 4px;
  background: #fff;
  padding: 8px;
}
</style>
